export function i18nUrl() {
  const ossJsonUrl: string = 'https://freelog-i18n.oss-cn-shenzhen.aliyuncs.com/configs/i18n.json';
const ossJsonUrl_Test: string = 'https://freelog-i18n.oss-cn-shenzhen.aliyuncs.com/configs-test/i18n.json';
const url: string = window.location.origin.includes('.freelog.cn') ? ossJsonUrl : ossJsonUrl_Test;
  return url;
}
